// Tradução amigável (pt-br) dos erros de envio da Meta (WhatsApp Cloud API).
// Cada entrada tem título curto, explicação e ação sugerida. O texto técnico
// original é sempre preservado em `tecnico` (exibido atrás de "ver detalhe").

// Mapa por CÓDIGO da Meta (mais confiável). Chaves como string.
const BY_CODE = {
  131047: {
    titulo: 'Cliente não respondeu nas últimas 24h',
    explicacao:
      'O WhatsApp só permite iniciar conversa fora da janela de 24h usando um template aprovado. Como o cliente não respondeu recentemente, a mensagem livre não é entregue.',
    acao: 'Use um template aprovado para reabrir a conversa.',
  },
  131026: {
    titulo: 'Mensagem não pôde ser entregue',
    explicacao:
      'O número pode não ter WhatsApp, estar incorreto, ou o aparelho não conseguiu receber. Também ocorre quando o destinatário não aceita mensagens da sua conta.',
    acao: 'Confira se o número está correto e tem WhatsApp ativo.',
  },
  131049: {
    titulo: 'Entrega bloqueada pela Meta (saúde da conta)',
    explicacao:
      'A Meta limitou esta entrega para preservar a experiência do usuário — geralmente por volume alto de marketing ou queda na qualidade do número.',
    acao: 'Reduza envios em massa e priorize mensagens relevantes; acompanhe a qualidade do número.',
  },
  131031: {
    titulo: 'Conta restrita ou bloqueada',
    explicacao: 'A conta do WhatsApp Business foi restrita pela Meta e não pode enviar mensagens no momento.',
    acao: 'Verifique o status da conta no Gerenciador da Meta e regularize as pendências.',
  },
  368: {
    titulo: 'Conta temporariamente bloqueada (política)',
    explicacao: 'A conta foi bloqueada temporariamente por violação das políticas do WhatsApp.',
    acao: 'Revise as políticas e aguarde a liberação; reincidências aumentam o bloqueio.',
  },
  130429: {
    titulo: 'Limite de envio atingido',
    explicacao: 'Você atingiu o limite de velocidade/quantidade de mensagens permitido pela Meta neste período.',
    acao: 'Aguarde e reduza o ritmo de envio. O limite aumenta conforme a conta amadurece.',
  },
  132000: {
    titulo: 'Quantidade de variáveis não bate com o template',
    explicacao:
      'O número de variáveis enviadas é diferente do que o template aprovado espera ({{1}}, {{2}}…).',
    acao: 'Ajuste o template no seu ERP para enviar exatamente as variáveis que o modelo aprovado usa.',
  },
  132001: {
    titulo: 'Template não encontrado',
    explicacao: 'O template informado não existe, não está aprovado, ou o idioma enviado não confere.',
    acao: 'Confira o nome e o idioma do template no Gerenciador da Meta.',
  },
  132005: {
    titulo: 'Conteúdo difere do template aprovado',
    explicacao: 'O texto enviado não corresponde ao conteúdo que a Meta aprovou para este template.',
    acao: 'Reenvie usando exatamente o conteúdo aprovado do template.',
  },
  132007: {
    titulo: 'Conteúdo viola as políticas',
    explicacao: 'O conteúdo do template foi recusado por violar as políticas do WhatsApp.',
    acao: 'Revise o texto do template e submeta uma nova versão para aprovação.',
  },
  132012: {
    titulo: 'Formato de variável inválido',
    explicacao: 'Algum parâmetro enviado está em formato inválido para o template (ex.: tipo errado).',
    acao: 'Verifique os valores das variáveis enviadas pelo ERP.',
  },
  133010: {
    titulo: 'Número não registrado',
    explicacao: 'O número da sua conta não está registrado/ativo na Cloud API.',
    acao: 'Finalize o registro do número no Gerenciador da Meta.',
  },
  100: {
    titulo: 'Parâmetro inválido na requisição',
    explicacao: 'Algum dado enviado à Meta está inválido ou faltando.',
    acao: 'Revise o template e as variáveis; veja o detalhe técnico para o campo exato.',
  },
}

// Casamento por PALAVRA-CHAVE no texto (quando não há código). Ordem importa:
// padrões mais específicos primeiro.
const BY_KEYWORD = [
  { re: /24\s*hours|re-?engagement|last replied/i, code: 131047 },
  { re: /template name .*does not exist|does not exist in|template.*not.*found/i, code: 132001 },
  { re: /number of (localizable_)?params|parameter count|expected \d+ param/i, code: 132000 },
  { re: /rate limit|too many|throughput/i, code: 130429 },
  { re: /restricted|account.*locked|disabled/i, code: 131031 },
  { re: /undeliverable|not.*registered on whatsapp|invalid.*recipient/i, code: 131026 },
  { re: /invalid parameter/i, code: 100 },
]

function normalizeCode(code) {
  if (code == null) return null
  const n = String(code).trim()
  return n || null
}

export function translateMetaError(erro) {
  if (!erro) return null
  const text = erro.text || erro.details || erro.title || ''
  const code = normalizeCode(erro.code)

  if (!text && !code) return null

  let entry = code ? BY_CODE[code] : null

  if (!entry && text) {
    const hit = BY_KEYWORD.find((k) => k.re.test(text))
    if (hit) entry = BY_CODE[hit.code]
  }

  if (entry) {
    return { ...entry, tecnico: text || null, code: code || null }
  }

  // Genérico: não reconhecido, mas preserva o técnico pra suporte.
  return {
    titulo: 'Falha no envio pela Meta',
    explicacao: 'A Meta recusou o envio desta mensagem. Veja o detalhe técnico para o motivo exato.',
    acao: 'Se persistir, contate o suporte com o detalhe técnico.',
    tecnico: text || null,
    code: code || null,
  }
}

export default { translateMetaError }
